// Ícones SVG das redes sociais nas cores do Nefastos
// Facebook, Instagram, YouTube

export function FacebookIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <circle cx="12" cy="12" r="12" fill="#000" />
      <path d="M15.5 8.5h-2V7.5c0-.4.3-.5.5-.5h1.5V5h-2c-1.7 0-2.5 1.3-2.5 2.5V8.5H8v2h2v6h2.5v-6h1.7l.3-2z" fill="#d3ab08"/>
    </svg>
  );
}

export function InstagramIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <circle cx="12" cy="12" r="12" fill="#000" />
      <rect x="7" y="7" width="10" height="10" rx="3" fill="#d3ab08"/>
      <circle cx="12" cy="12" r="2.5" fill="#000"/>
      <circle cx="16.2" cy="7.8" r="0.8" fill="#000"/>
    </svg>
  );
}

export function YoutubeIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <circle cx="12" cy="12" r="12" fill="#000" />
      <rect x="7" y="9" width="10" height="6" rx="2" fill="#d3ab08"/>
      <polygon points="11,10 15,12 11,14" fill="#000"/>
    </svg>
  );
}
